import { Navigate, Outlet } from "react-router-dom";
import { SecureNavbar } from "../components/navbar";

import { BaseProps } from "../model/auth";
import { Container } from "reactstrap";
import { Footer } from "./footer";

interface SecureLayoutProps extends BaseProps {
  openMenu: boolean;
  isAuthenticated: boolean;
}

export const SecureLayout = (props: SecureLayoutProps) => {
  if (!props.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      <div className="d-flex">
        <SecureNavbar {...props} tokenUser={props.tokenUser} openMenu={props.openMenu} />
        <Container fluid className="p-0 secure-app">
          <Outlet />
        </Container>
      </div>
      <Footer />
    </>
  );
};
